import React, { Component } from 'react';
import classNames from 'classnames';

import style from './ModalHeader.module.scss';

interface Props {
  children?: JSX.Element | null;
  className?: string;
}

class ModalHeader extends Component<Props> {
  render() {
    const { className, children } = this.props;

    return (
      <div className={classNames(style.header, className)}>{children}</div>
    );
  }
}

export default ModalHeader;
